type Args = {
  message: string;
  // MEMO: SHA-1 はセキュリティ上の問題があるため使用しない
  algorithmIdentifier?: 'SHA-256' | 'SHA-384' | 'SHA-512';
};

export function digestMessage(
  args: Args & { convertsToHex?: true }
): Promise<string | undefined>;
export function digestMessage(
  args: Args & { convertsToHex: false }
): Promise<ArrayBuffer | undefined>;

/**
 * {@link https://developer.mozilla.org/en/docs/Web/API/SubtleCrypto/digest}
 */
export async function digestMessage(
  args: Args & { convertsToHex?: boolean }
): Promise<string | ArrayBuffer | undefined> {
  const {
    message,
    algorithmIdentifier = 'SHA-256',
    convertsToHex = true,
  } = args;

  if (window === undefined) return;

  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest(
    algorithmIdentifier,
    msgUint8
  );

  if (convertsToHex) {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  }

  return hashBuffer;
}
